import React from "react";
import EditHostelCard from "./EditHostelCard.component";
import HostelStore from "../../../../../../store/Operational/Residential/Hostel";

const HostelEdit = () => {
  const { setHostelId, setAction } = HostelStore();
  const handelHostelDetails = (hostelId, action) => {
    setHostelId(hostelId);
    setAction(action);
  };
  return (
    <div className="editHostelContainer pb-1">
      {[...Array(5)].map((_, index) => {
        return (
          <EditHostelCard
            key={index}
            handelHostelDetails={handelHostelDetails}
            _hostelId={index + 1}
          />
        );
      })}
    </div>
  );
};

export default HostelEdit;
